module.exports = __webpack_public_path__ + "static/resiliency-c6420386254f8227bc45d4750fc377c8.svg";